import {useState} from 'react'
import {useSelector} from 'react-redux'
import {authorizationHeaderFromAccessToken} from '../auth'
import {API_URL} from '../config'
import {MentorId} from '../domain/mentor'
import {captureException} from '../errors'
import ServerError from '../errors/server'
import {getAccessToken} from '../store/authentication/authentication.selectors'

type Options = Readonly<{
  onError?: (error: Error) => void
  onSuccess?: () => void
}>

function useDeleteMentor({onError, onSuccess}: Options): {
  busy: boolean
  deleteMentor: (id: MentorId, deleteOrphanedLearners: boolean) => void
  error: Error | null
} {
  const accessToken = useSelector(getAccessToken)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const deleteMentor = (id: MentorId, deleteOrphanedLearners: boolean) => {
    setBusy(true)
    setError(null)

    fireDeleteMentor(accessToken, id, deleteOrphanedLearners)
      .then(() => onSuccess?.())
      .catch(error => {
        captureException(error)
        setError(error)
        onError?.(error)
      })
  }

  return {busy, deleteMentor, error}
}

async function fireDeleteMentor(
  accessToken: string,
  id: MentorId,
  deleteOrphanedLearners: boolean
): Promise<void> {
  const url = new URL(`mentors/${id}`, API_URL)
  url.searchParams.append('deleteOrphanedLearners', `${deleteOrphanedLearners}`)

  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      ...authorizationHeaderFromAccessToken(accessToken)
    }
  })

  if (response.status !== 204) {
    return ServerError.fromResponse(response)
  }
}

export default useDeleteMentor
